import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start near 23:59:37
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-12 bg-mystic-900 border-b border-mystic-800" data-id="element-58">
      <div className="max-w-4xl mx-auto text-center px-4" data-id="element-59">
        <div className="flex items-center justify-center gap-2 text-gold-400 font-bold mb-6 tracking-wider uppercase text-sm md:text-base" data-id="element-60">
          <Clock className="w-5 h-5" data-id="element-61" />
          <span data-id="element-62">⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO</span>
        </div>

        <div className="flex justify-center gap-4 md:gap-8 mb-6" data-id="element-63">
          <div className="flex flex-col items-center" data-id="element-64">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-mystic-800 rounded-xl flex items-center justify-center text-3xl md:text-4xl font-bold text-white border border-mystic-700 shadow-inner" data-id="element-65">
              {format(timeLeft.hours)}
            </div>
            <span className="text-xs text-slate-400 mt-2 uppercase font-medium" data-id="element-66">
              HS
            </span>
          </div>
          <div className="text-3xl md:text-4xl font-bold text-mystic-700 mt-4" data-id="element-67">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-68">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-mystic-800 rounded-xl flex items-center justify-center text-3xl md:text-4xl font-bold text-white border border-mystic-700 shadow-inner" data-id="element-69">
              {format(timeLeft.minutes)}
            </div>
            <span className="text-xs text-slate-400 mt-2 uppercase font-medium" data-id="element-70">
              MIN
            </span>
          </div>
          <div className="text-3xl md:text-4xl font-bold text-mystic-700 mt-4" data-id="element-71">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-72">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-mystic-800 rounded-xl flex items-center justify-center text-3xl md:text-4xl font-bold text-white border border-mystic-700 shadow-inner" data-id="element-73">
              {format(timeLeft.seconds)}
            </div>
            <span className="text-xs text-slate-400 mt-2 uppercase font-medium" data-id="element-74">
              SEG
            </span>
          </div>
        </div>

        <motion.div animate={{
        opacity: [0.5, 1, 0.5]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="text-red-400 font-medium text-sm md:text-base" data-id="element-75">
          🔴 El precio sube cuando termina el contador
        </motion.div>
      </div>
    </section>;
}